
import { defineComponent } from "vue";

const __default__ = defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: ""
    },
    label: {
      type: String,
      required: false,
      default: ""
    },
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    max: {
      type: [Number, String],
      required: false
    },
    min: {
      type: [Number, String],
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ""
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    borderRadius: {
      type: String,
      default: "10px"
    },
    widthInput: {
      type: String,
      default: "100%"
    }
  },
  setup(_props, { emit }) {
    const onInput = async (event: Event) => {
      const input = event.target as HTMLInputElement;

      if (!input.value || input.value === "") {
        emit("update:modelValue", input.value);
        return;
      }

      emit("update:modelValue", input.value);
    };

    return { onInput };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "bc469e1a": (_ctx.widthInput),
  "bcd7a126": (_ctx.borderRadius)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__